/**
 * @tabler/icons-react v2.44.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconAppWindow = createReactComponent("app-window", "IconAppWindow", [
  [
    "path",
    {
      d: "M3 5m0 2a2 2 0 0 1 2 -2h14a2 2 0 0 1 2 2v10a2 2 0 0 1 -2 2h-14a2 2 0 0 1 -2 -2z",
      key: "svg-0"
    }
  ],
  ["path", { d: "M6 8h.01", key: "svg-1" }],
  ["path", { d: "M9 8h.01", key: "svg-2" }]
]);

export { IconAppWindow as default };
//# sourceMappingURL=IconAppWindow.js.map
